import React, { createContext, useContext, useState, useMemo } from 'react';
import { LESSORS, LESSOR_BY_ID } from '../data/lessors';
import { getGlobalCookie } from '../utils';

const AppContext = createContext({
  operator: '',
  status: '',
  hasAccess: false,
  lessorMeta: {},
  D: {},
  LIVE: [],
  OPC: {},
  PAL: [],
  OPERATORS: [],
  setOperator: () => {},
  setStatus: () => {},
});

function resolveLessorFromCookie() {
  try {
    const raw = getGlobalCookie('lessorAccess');
    if (!raw) return null;
    const { id } = JSON.parse(raw);
    const key = LESSOR_BY_ID[Number(id)];
    return key ? LESSORS[key] : null;
  } catch {
    return null;
  }
}

export function AppProvider({ children }) {
  const [operator, setOperator] = useState('');
  const [status, setStatus]     = useState('');

  const lessor = useMemo(() => resolveLessorFromCookie(), []);

  const hasAccess = lessor !== null;

  const { D, LIVE, OPC, PAL } = hasAccess
    ? lessor.module
    : { D: {}, LIVE: [], OPC: {}, PAL: [] };

  const OPERATORS = useMemo(() => Object.keys(OPC), [OPC]);

  const lessorMeta = useMemo(() => hasAccess ? ({
    id:     lessor.id,
    name:   lessor.name,
    badge:  lessor.badge,
    accent: lessor.accent,
  }) : {}, [lessor, hasAccess]);

  return (
    <AppContext.Provider value={{
      operator, setOperator,
      status, setStatus,
      hasAccess,
      D, LIVE, OPC, PAL, OPERATORS,
      lessorMeta,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}

export default AppContext;
